import { render, staticRenderFns } from "./TaxCpiRateGrowth.vue?vue&type=template&id=b97610ce&scoped=true&"
import script from "./TaxCpiRateGrowth.vue?vue&type=script&lang=js&"
export * from "./TaxCpiRateGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97610ce",
  null
  
)

export default component.exports